import React from 'react';

import { ScreenHead } from '../../ui/screen-parts.js';
import { Chip, Kpis, Panel, useFlash } from '../../ui/kit.js';
import { useBuilding } from '../../state/building.js';

import WorkOrdersPhoto from '../../media/images/modules/work-orders.jpg';

const COLUMNS = ['New', 'Assigned', 'In progress', 'Done'];
const TECHS = ['Luis M.', 'Dana K.', 'Omar R.'];

/* Service Requests / Work Orders, the staff half: every request from every
   unit, moved across the board one step at a time. */
function WorkOrdersScreen() {
    const { workOrders, patch } = useBuilding();
    const [flash, notify] = useFlash();

    const advance = order => {
        const next = COLUMNS[COLUMNS.indexOf(order.status) + 1];
        if (!next) return;

        const changes = { status: next };
        if (next === 'Assigned' && !order.assignee) changes.assignee = TECHS[order.id % TECHS.length];

        patch('workOrders', order.id, changes);
        notify(`${order.title} (${order.unit}) moved to ${next}.${next === 'Done' ? ' The resident has been notified.' : ''}`);
    };

    const count = status => workOrders.filter(w => w.status === status).length;

    return (
        <div className="screen-content">
            <ScreenHead eyebrow="Work orders" title="Maintenance board" />

            <div className="banner">
                <img src={WorkOrdersPhoto} alt="" />
                <p className="banner__caption">Every resident request, from first report to fixed.</p>
            </div>

            <Kpis items={[
                { label: 'Open', value: workOrders.length - count('Done'), tone: 'info' },
                { label: 'Unassigned', value: count('New'), tone: count('New') ? 'warn' : undefined },
                { label: 'Urgent', value: workOrders.filter(w => w.priority === 'High' && w.status !== 'Done').length, tone: 'alert' },
                { label: 'Closed this week', value: count('Done'), tone: 'ok' }
            ]} />

            {flash}

            <div className="board">
                {COLUMNS.map(column => (
                    <div className="board__col" key={column}>
                        <div className="board__head">
                            <span>{column}</span>
                            <span>{count(column)}</span>
                        </div>

                        {workOrders.filter(w => w.status === column).map((order, i) => (
                            <Panel className="board__card" key={order.id} index={i} layout>
                                <div className="row__end" style={{ justifyContent: 'space-between' }}>
                                    <Chip tone="muted">{order.unit}</Chip>
                                    {order.priority === 'High' && <Chip tone="alert">Urgent</Chip>}
                                </div>
                                <h4>{order.title}</h4>
                                <p className="row__meta">
                                    {order.category} · {order.opened}
                                    {order.assignee ? ` · ${order.assignee}` : ''}
                                    {order.entry ? ' · entry OK' : ''}
                                </p>
                                {column !== 'Done' && (
                                    <button type="button" className="btn btn-outline-light btn-sm" onClick={() => advance(order)}>
                                        {column === 'New' ? 'Assign' : column === 'Assigned' ? 'Start work' : 'Mark done'}
                                    </button>
                                )}
                            </Panel>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default WorkOrdersScreen;
